import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`

html{
  /* 1rem = 10px */
  font-size:62.5%;
}

* {
  direction:rtl;
  font-family:dana;
}

h1,h2,h3,h4,h5,h6,p{
  margin:0;
}

body{
  font-family: anjoman;
  text-align:right;
  margin:0;
  box-sizing: border-box;
  overflow: auto; 
  background-color:${(props) => props.theme.colors.BLACK_2};
  overflow-x:hidden;
}

.Toastify__toast-body{
  font-size:3rem;
}

#root{
  z-index:1;
}
#modal{
  z-index:10
}

#selector-modal{
  z-index:100;
}


/*HD TV Screen*/
@media screen and (min-width: 1080px) {
  html {
    font-size: 28.5%;
  }
}

/*FULL-HD TV Screen*/
@media screen and (width: 1920px) {
  html {
    font-size: 50%;
  }
}

/*FULL-HD TV Screen*/
@media screen and (min-width: 3840px) {
  html {
    font-size: 100%;
  }
}
`;
